// Function to handle scroll behavior
const handleScroll = () => {
  const widget = document.querySelector('recharge-subscription-widget');
  if (!widget) return;

  const shadow = widget.shadowRoot;
  if (!shadow) return;

  // Get the main container from the shadow DOM - targeting the root element
  const container = shadow.querySelector('.rc-widget__root');
  if (!container) return;

  const addToCartButton = document.querySelector('.product-form__buttons');
  if (!addToCartButton) return;

  const productTitle = document.querySelector('.product__title');
  if (!productTitle) return;

  const rechargeWidget = document.querySelector('.recharge-subscription-widget');
  if (!rechargeWidget) return;

  // Get the scroll position and calculate threshold based on viewport height
  const scrollPosition = window.scrollY;
  const viewportHeight = window.innerHeight;
  let isMobile = window.innerWidth < 768;
  const threshold = isMobile ? viewportHeight * 2.5 : viewportHeight * 1.5; // 120vh
  const documentHeight = document.documentElement.scrollHeight;
  const bottomThreshold = documentHeight - viewportHeight - 400; // 400px before bottom
  const bufferZone = isMobile ? 180 : 300; // Buffer zone to prevent flickering

  // Check if we're in the buffer zone
  const isInTopBuffer = scrollPosition > threshold - bufferZone && scrollPosition < threshold + bufferZone;
  const isInBottomBuffer = scrollPosition > bottomThreshold && scrollPosition < bottomThreshold + bufferZone;

  // Only change state if we're not in a buffer zone
  if (!isInTopBuffer && !isInBottomBuffer) {
    if (scrollPosition > threshold && scrollPosition < bottomThreshold) {
      container.classList.add('fixedOnScroll');
      addToCartButton.classList.add('fixedOnScrollATC');
      productTitle.classList.add('fixedOnScrollPT');
      rechargeWidget.classList.add('fixedOnScrollRecharge');
    } else {
      container.classList.remove('fixedOnScroll');
      addToCartButton.classList.remove('fixedOnScrollATC');
      productTitle.classList.remove('fixedOnScrollPT'); 
      rechargeWidget.classList.remove('fixedOnScrollRecharge');
    }
  }
};

// Add scroll event listener
window.addEventListener('scroll', handleScroll);
// Also listen for resize to recalculate threshold
window.addEventListener('resize', handleScroll);

// Wait for the widget to be available and initialize
const scrollFixedWidget = setInterval(() => {
  const widget = document.querySelector('recharge-subscription-widget');
  if (widget && widget.shadowRoot) {
    const shadow = widget.shadowRoot;
    clearInterval(scrollFixedWidget);
    handleScroll(); // Initial check
  }
}, 300); 